import type { HTMLAttributes, ReactNode } from "react";

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  padded?: boolean;
}

export function Card({ children, padded = true, className, ...rest }: CardProps) {
  return (
    <div className={["card", padded ? "card-padded" : "", className ?? ""].join(" ").trim()} {...rest}>
      {children}
    </div>
  );
}

export function CardHeader({ eyebrow, title, aside }: { eyebrow?: string; title?: ReactNode; aside?: ReactNode }) {
  return (
    <div className="card-header">
      <div>
        {eyebrow === undefined ? null : <Eyebrow>{eyebrow}</Eyebrow>}
        {title === undefined ? null : <h2 className="card-title">{title}</h2>}
      </div>
      {aside === undefined ? null : <div className="card-aside">{aside}</div>}
    </div>
  );
}

export function Eyebrow({ children, live = false }: { children: ReactNode; live?: boolean }) {
  return (
    <div className="eyebrow">
      {live ? <span className="live-dot" aria-hidden="true" /> : null}
      {children}
    </div>
  );
}
